import axios from "axios";
import "../../common/axiosInterceptor/axios-interceptor";

export const SoftwareVersionUploadAPI = async (data) => {
    return axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/saveVersionNumber`,
        data: data,
        authRequired: true
    })
}